import React from 'react';

import { BrandedSpinner, LoadingContainer } from './loading-component-styles';

export const Loading = () => {
  return (
    <LoadingContainer>
      <BrandedSpinner isShowing label="Loading" pattern="jumbo" isPolite />
    </LoadingContainer>
  );
};
